module.exports = __webpack_public_path__ + "img/skin-appearance.f619b6a4.svg";